/* import __COLOCATED_TEMPLATE__ from './sla-delete-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();